import {
  ChevronRightIc,
  Dialog,
  ThumbIc,
  ThumbIcS,
} from "@/components/Elements";
import useToggle from "@/hooks/useToggle";
import { useGetPostUsersMutation } from "@/services/modules/post";
import { useGetPostCommentsMutation } from "@/services/modules/postComment";
import { PostModel } from "@/types/post";
import { useEffect, ReactNode } from "react";
import ActionBtn from "../../../misc/components/ActionBtn";
import { themeTextColor } from "@/utils/colorConstant";
import CommentList from "./CommentList";
import AddComment from "./AddComment";

function AddViewComment({
  postDetail,
  children,
  handleLikeDislike,
}: {
  postDetail: PostModel;
  children: ReactNode;
  handleLikeDislike: (like: boolean) => void;
}) {
  const { show: showModal, toggle: toggleModal } = useToggle();
  const { postId, likeCount, likeStatus } = postDetail;

  const [getComments] = useGetPostCommentsMutation();
  const [getPostUsers] = useGetPostUsersMutation();

  useEffect(() => {
    if (showModal) {
      getComments({ postId });
      getPostUsers({ postId });
    }
  }, [postId, showModal]);

  return (
    <>
      <div onClick={toggleModal}>{children}</div>
      {showModal && (
        <Dialog isOpen={showModal} onClose={toggleModal} hideHeader>
          <div className="min-w-[200px] min-h-[200px]">
            <div className="flex justify-between m-4 w-full">
              <div className="flex">
                <ActionBtn text={likeCount}>
                  <ThumbIc className={`w-6 h-6 ${themeTextColor}`} />
                </ActionBtn>
                <ActionBtn text="" onClick={toggleModal}>
                  <ChevronRightIc className={`w-6 h-6 ${themeTextColor}`} />
                </ActionBtn>
              </div>
              <ActionBtn onClick={() => handleLikeDislike(true)} text="">
                {likeStatus ? (
                  <ThumbIcS className={`w-6 h-6 ${themeTextColor}`} />
                ) : (
                  <ThumbIc className={`w-6 h-6 ${themeTextColor}`} />
                )}
              </ActionBtn>
            </div>
            <div className="flex-1">
              <div className="flex-1 p-[10px] max-h-48 overflow-auto">
                <CommentList postId={postId} />
              </div>
              <AddComment postId={postId} />
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

export default AddViewComment;
